import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { getSortableDate, getSortableTime } from 'src/app/utlis';

@Component({
  selector: 'app-cancelled-appointments-v2',
  templateUrl: './cancelled-appointments-v2.component.html',
  styleUrls: ['./cancelled-appointments-v2.component.scss'],
})
export class CancelledAppointmentsV2Component implements OnInit, AfterViewInit {
  // cancelledAppointments: any;
  show: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private appointmentService: AppointmentService
  ) {}

  appointments: any = [];
  filterForm!: FormGroup;
  status!: string;

  ngAfterViewInit(): void {
    this.dtTrigger.next(this);
  }

  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(this);
    });
  }

  ngOnInit(): void {
    this.show = false;
    this.spinner.show();
    let location = null;
    let diagId = null;
    this.status = 'CANCEL';
    this.appointmentService
      .getAppointments(null, null, this.status, null, null, null)
      .subscribe((res) => {
        this.appointments = res.data;

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        }
        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };

        this.rerender();
        this.show = true;
        this.spinner.hide();
      });

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
      searchTerm: [''],
    });
  }

  submitFilterForm() {
    this.spinner.show();
    const fromDate = this.filterForm.get('fromDate')?.value;
    const toDate = this.filterForm.get('toDate')?.value;

    this.appointmentService
      .getAppointments(null, null, this.status, null, fromDate, toDate)
      .subscribe((res) => {
        this.appointments = res.data || [];

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        }

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };

        this.rerender();
        this.show = true;
        this.spinner.hide();
      });
  }

  getSortableTime(timeRangeStr: string) {
    return getSortableTime(timeRangeStr);
  }

  getSortableDate(dateStr: string): string {
    return getSortableDate(dateStr);
  }
}
